




import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Layout extends Vue {}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/certificate/components/header/Header.vue